import "core-js/modules/es6.string.small";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/feature.svg';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import SubtitlePage from '~/components/atoms/Editorial/SubtitlePage.vue';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'SimpleHeaderNoBackground',
  components: {
    GlobalTitle: GlobalTitle,
    SubtitlePage: SubtitlePage
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      mobile: null
    };
  },
  computed: {
    title: function title() {
      return this.payload.primary.title[0];
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0];
    },
    svgColor: function svgColor() {
      return this.payload.primary.svg_color;
    },
    imageAlt: function imageAlt() {
      return this.payload.primary.image_alt;
    },
    showTitleSection: function showTitleSection() {
      return this.title.text !== '' || this.subtitle.text !== '';
    },
    imageSrc: function imageSrc() {
      if (this.mobile === null) {
        // SSR, do not render image to avoid flickering
        return EMPTY_PIXEL;
      }

      return this.mobile ? formatPrismicImage(this.payload.primary.image.small.url, ['w_100']) : formatPrismicImage(this.payload.primary.image.url, ['w_375']);
    },
    imageSrcset: function imageSrcset() {
      var url = this.payload.primary.image.url;
      var smallUrl = this.payload.primary.image.small.url || url;

      if (!url) {
        return null;
      }

      var small = formatPrismicImage(smallUrl, ['w_375']);
      var medium = formatPrismicImage(smallUrl, ['w_375,dpr_2']);
      var large = formatPrismicImage(url, ['w_1440']);
      var xlarge = formatPrismicImage(url, ['w_1440,dpr_2']);
      return "".concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 2000w, ").concat(xlarge, " 2880w");
    }
  },
  mounted: function mounted() {
    this.mobile = this.isMobile();
  }
};